import { createContext, useContext } from "react";

interface ModifiedCellsContextValue {
  modifiedCells: Set<string>;
}

const ModifiedCellsContext = createContext<ModifiedCellsContextValue>({
  modifiedCells: new Set(),
});

export const ModifiedCellsProvider = ModifiedCellsContext.Provider;

/**
 * 수정된 셀인지 확인하는 훅
 * @param nursesIndex - 간호사 인덱스 (0-based)
 * @param dayIndex - 날짜 인덱스 (0-based)
 * @returns 해당 셀이 수정되었는지 여부
 */
export function useIsModifiedCell(
  nursesIndex: number,
  dayIndex: number
): boolean {
  const { modifiedCells } = useContext(ModifiedCellsContext);
  return modifiedCells.has(`${nursesIndex}-${dayIndex}`);
}

export default ModifiedCellsContext;
